import ApiClient from './ApiClient';

// SiteUp: liga/desliga na propria conta as funcoes vendaveis que moram em
// settings['custom_features']. GET lista as 13, PATCH /:key liga/desliga uma.
class AccountModulesAPI extends ApiClient {
  constructor() {
    super('account_modules', { accountScoped: true });
  }
}

export default new AccountModulesAPI();
